export function formatDateInRome(epochSeconds) {
    const date = new Date(epochSeconds * 1000);
    const romeTimeOptions = { timeZone: 'Europe/Rome' };
    const currentDate = new Date();
    const currentDateInRome = new Intl.DateTimeFormat('en-GB', {
        ...romeTimeOptions,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    }).format(currentDate);
    const targetDateInRome = new Intl.DateTimeFormat('en-GB', {
        ...romeTimeOptions,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    }).format(date);
    if (currentDateInRome === targetDateInRome) {
        return new Intl.DateTimeFormat('en-GB', {
            ...romeTimeOptions,
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).format(date);
    } else {
        return new Intl.DateTimeFormat('en-GB', {
            ...romeTimeOptions,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).format(date);
    }
}

